import { render, staticRenderFns } from "./SystemBans.vue?vue&type=template&id=a3ae19e0&scoped=true"
import script from "./SystemBans.vue?vue&type=script&lang=js"
export * from "./SystemBans.vue?vue&type=script&lang=js"
import style0 from "./SystemBans.vue?vue&type=style&index=0&id=a3ae19e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3ae19e0",
  null
  
)

export default component.exports